import { render, staticRenderFns } from "./ShiftAttendance.vue?vue&type=template&id=506d0146&"
import script from "./ShiftAttendance.vue?vue&type=script&lang=ts&"
export * from "./ShiftAttendance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports